module.exports = __webpack_public_path__ + "static/wwf-bus-aeb05660b3ef1b4615aa3613122ed025.jpg";